import { Info } from 'lucide-react';
import type { Message } from '@/lib/agents/types';
import { AssistantMessage } from './AssistantMessage';
import { UserMessage } from './UserMessage';

export function MessageBlock({ message, streaming = false }: { message: Message; streaming?: boolean }) {
  if (message.role === 'user') return <UserMessage message={message} />;
  if (message.role === 'assistant') return <AssistantMessage message={message} streaming={streaming} />;
  // system message
  const text = message.parts
    .filter((p) => p.type === 'text')
    .map((p) => (p as { type: 'text'; text: string }).text)
    .join('\n');
  return (
    <div className="my-2 flex items-start gap-2 rounded-md border border-border bg-surface/60 px-3 py-2 text-[12.5px] text-fg-muted">
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-info" />
      <pre className="whitespace-pre-wrap font-sans">{text}</pre>
    </div>
  );
}
